import React, { useState, useEffect } from 'react';
import * as R from 'ramda';
import { path } from 'ramda';

const UserContext = /*#__PURE__*/React.createContext({});
function UserContextProvider(props) {
  const [userInfo, setUserInfo] = useState({});
  const {
    global
  } = props;
  const affiliate = path(['authentication', 'affiliatedAuthenticated', 'affiliateInfo'], global);
  const setCompleteInfo = user => {
    const getFromUser = field => R.propOr('', field, user);
    const name = `${getFromUser(`firstName`)} ${getFromUser(`fatherLastname`)}`;
    let usertype = '';
    const cuspp = getFromUser('idAffiliate');
    // const idApplicant = getFromUser('idApplicant');

    if (!!cuspp) {
      usertype = 'affiliate';
    } else {
      usertype = 'applicant';
    }
    const userCompleteInfo = {
      name,
      usertype,
      cuspp,
      ...user
    };
    setUserInfo(userCompleteInfo);
  };
  useEffect(() => {
    if (affiliate) {
      setCompleteInfo(affiliate);
    }
  }, [affiliate]);
  return /*#__PURE__*/React.createElement(UserContext.Provider, {
    value: userInfo
  }, props.children);
}
function useUserContext() {
  const context = React.useContext(UserContext);
  if (!context) {
    throw new Error('UserContextProvider provider is required');
  }
  return context;
}
const useWithUserInfo = (ComponentToInject, providerProps) => props => {
  return /*#__PURE__*/React.createElement(UserContextProvider, providerProps, /*#__PURE__*/React.createElement(ComponentToInject, props));
};
var UserInfoContext = {
  UserContextProvider,
  useUserContext,
  useWithUserInfo
};

export { UserContextProvider, UserInfoContext as default, useUserContext, useWithUserInfo };
